import React, { useState } from 'react';
import './referral-link.css';
import { CheckIcon } from 'nexticons/outline';
import { ReactComponent as ReferralIcon } from '../../assets/images/referral-icon.svg';
import { ReactComponent as CopyIcon } from '../../assets/images/copy-icon.svg';

const ReferralLink = ({ 
  userLoyaltyDetails,
  themeColors,
  pointsTerminology = 'points',
  referralRule
}) => {
  const [copied, setCopied] = useState(false);
  // Generate referral URL
  const generateReferralUrl = () => {
    const referralId = userLoyaltyDetails?.id || userLoyaltyDetails?.userId;
    
    return `${window.location.origin}/loyalty?refId=${referralId}`;
  };

  const referralUrl = generateReferralUrl();

  const handleCopyToClipboard = async () => {
    if (!referralUrl) return;

    try {
      await navigator.clipboard.writeText(referralUrl);
      setCopied(true);
      
      // Reset copied state after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = referralUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Always render for now since we have fallback values
  if (!userLoyaltyDetails) {
    return null;
  }

  // Get points from referral rule
  const referralPoints = referralRule?.points || 0;
  
  return (
    <div className="referral-link-container">
      <div className="referral-link-header">
        <div className="referral-icon-wrapper">
          <ReferralIcon 
            width="24" 
            height="24" 
            style={{ 
              color: themeColors.backgroundColor
            }}
          />
        </div>
        <div className="referral-text">
          <h4 className="referral-title">Share & Earn</h4>
          <p className="referral-description">
            Invite friends and earn {referralPoints} {pointsTerminology} for each referral
          </p>
        </div>
      </div>

      <div className="referral-link-wrapper">
        <div className="referral-url-container">
          <input
            type="text"
            value={referralUrl}
            readOnly
            className="referral-url-input"
          />
          <button
            onClick={handleCopyToClipboard}
            className="copy-button"
            data-tooltip={copied ? "Copied!" : "Copy"}
            style={{ 
              backgroundColor: copied ? '#10B981' : themeColors.backgroundColor,
              transition: 'all 0.2s ease'
            }}
          >
            {copied ? (
              <>
                <CheckIcon />
              </>
            ) : (
              <>
                <CopyIcon 
                  width="16" 
                  height="16" 
                  style={{ 
                    color: 'white'
                  }}
                />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferralLink; 
